<template>
  <v-app :class="{ 'finder-opened': finder_visibility }">
    <TopBar />
    <NotificationBanner />

    <LeftBar />
    <QuestionTopicMngtDialog />
    <ChangesApprovalDialog />
    <WaitApprovalDialog />
    <BrowseMotionDialog />
    <DeleteItemDialog />

    <v-main style="height: 100vh">
      <router-view v-slot="{ Component }">
        <transition>
          <component :is="Component" />
        </transition>
      </router-view>
    </v-main>
    <SnackBar />
  </v-app>
</template>

<script setup>
import TopBar from '@/components/NavBars/TopBar'
import NotificationBanner from '@/components/Widgets/NotificationBanner'
import LeftBar from '@/components/NavBars/LeftBar'
import QuestionTopicMngtDialog from '@/components/Dialogs/QuestionTopicMngtDialog'
import ChangesApprovalDialog from '@/components/Dialogs/ChangesApprovalDialog'
import WaitApprovalDialog from '@/components/Dialogs/WaitApprovalDialog'
import BrowseMotionDialog from '@/components/Dialogs/BrowseMotionDialog'
import DeleteItemDialog from '@/components/Dialogs/DeleteItemDialog'
import SnackBar from '@/components/Widgets/SnackBar'

import Falcon from '@/services/falcon'
const FALCON = new Falcon()

import { computed, onMounted, watch } from 'vue'

import { useStore } from 'vuex'
const store = useStore()
const login_status = computed(() => store.state.auth.status)
const finder_visibility = computed(() => store.state.topicDataFinderDialog.visibility)

watch(login_status, () => {
  if (login_status.value) FALCON.initialize()
  else FALCON.reset()
})

onMounted(() => {
  if (login_status.value) FALCON.initialize()
})
</script>

<style>
/* Modifying the z-index of autocomplete list in topic data finder */
.finder-opened .v-menu__content {
  z-index: 202 !important;
}

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap');
* {
  font-family: 'Open Sans', sans-serif !important;
}

html {
  overflow: overlay;
}

/* page */
.page-title {
  font-size: 34px;
  font-weight: 700;
  line-height: 24px;
}

.dialog-title {
  text-wrap: wrap;
  color: rgba(0, 0, 0, 0.87);
  font-size: 24px;
  font-weight: 700;
  line-height: 116%;
}

.card-title {
  color: #1b1b1b;
  font-size: 20px;
  font-weight: 700;
  line-height: 125%;
}

.grey-card-title {
  color: #828282;
  font-size: 20px;
  font-weight: 700;
  line-height: 125%;
}

.white-card-title {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  line-height: 125%;
}

.dialog-subtitle {
  color: #1b1b1b;
  font-size: 16px;
  font-weight: 400;
  line-height: 130% !important;
}

.btn-menu-title {
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
}

.black-title-text {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.grey-title-text {
  color: #828282;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.black-small-title {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
}

.grey-small-title {
  color: #828282;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
}

.number-order-text {
  color: #808080;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.btn-menu-field-title {
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.black-subtitle-text {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.grey-subtitle-text {
  color: #828282;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}

.selection-label {
  color: #211f20;
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
}

.black-small-text {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.grey-small-text {
  color: #828282;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.content-text {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.1px !important;
}

.grey-small-desc {
  color: #828282;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.3px;
}

.black-small-desc {
  color: #1b1b1b;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.3px;
}

.small-btn {
  color: #1b1b1b;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: 0.1px !important;
  max-height: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

.grey-background {
  border-radius: 12px !important;
  background-color: #f5f5f5 !important;
}

.v-switch .v-selection-control {
  min-height: 0;
}

.v-select {
  background-color: #ffffff;
}

.card-icon {
  position: absolute !important;
  top: 35%;
  right: 5%;
}

.outline-card {
  border-radius: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.small-chip-btn {
  border: 1px solid rgba(0, 0, 0, 0.4);
}

.v-tab.v-tab {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: normal;
}

.rounded-btn {
  min-width: 0px !important;
}

.icon-btn {
  min-height: 0 !important;
  min-width: 0 !important;
  height: 36px !important;
  width: 50px !important;
}

.v-btn:not(.small-btn):not(.content-text) span {
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: normal;
}

/* v-chip */
.v-chip {
  font-size: 14px !important;
  height: 28px !important;
}

.v-chip--outlined {
  border-color: rgba(0, 0, 0, 0.2) !important;
  color: #1b1b1b !important;
}

.selected-chip {
  background: rgba(27, 101, 242, 0.2) !important;
  color: rgba(27, 101, 242, 1) !important;
}

.chip-btn {
  height: 28px !important;
  min-height: 28px !important;
  border-radius: 16px !important;
  border: 1px solid rgb(0, 0, 0, 0.4);
  color: #1b1b1b !important;
  font-size: 14px !important;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.selected-chip-btn {
  background-color: rgba(27, 101, 242, 0.08) !important;
  color: #1b65f2 !important;
  border: none;
}

:not(.chip-btn, .content-text) > .v-btn__content {
  letter-spacing: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
}

.selected-chip-icon,
.selected-chip-text {
  color: rgba(27, 101, 242, 1) !important;
}

/* Tag input */
.vue-tags-input .ti-new-tag-input {
  background: transparent;
  color: #000000;
}

.vue-tags-input .ti-input {
  padding: 0px;
  transition: border-bottom 200ms ease;
  border: none !important;
}

.vue-tags-input .ti-tag {
  position: relative;
  padding: 8px 10px !important;
  border-radius: 9999px !important;
  background: #e3e3e3 !important;
  color: #000 !important;
}

/* Timepicker */
.vue__time-picker .dropdown ul li:not([disabled]).active {
  background: #1b65f2 !important;
}
.vue__time-picker input.has-custom-icon {
  padding-left: 2rem !important;
}

/* v-menu */
.v-menu > .v-overlay__content.popup-menu {
  border-radius: 8px;
  background: #fff;
  box-shadow:
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12),
    0px 2px 4px 0px rgba(0, 0, 0, 0.2);
}

.menu-font {
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
}

.v-menu__content {
  background: #ffffff;
}

.btn-menu {
  border-radius: 8px;
  box-shadow:
    0px 2px 4px 0px rgba(0, 0, 0, 0.2),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14);
}

/* v-tooltip */
.v-tooltip__content {
  opacity: 1 !important;
}

.tooltip-transparent-background {
  background-color: transparent !important;
  border-color: transparent !important;
}

.tooltip-color {
  color: #ffffff !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.3px;
  background-color: rgba(0, 0, 0, 0.6) !important;
  border-color: rgba(0, 0, 0, 0.6) !important;
  border-radius: 8px;
}

.tooltip-top::before {
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  transform: translateX(-50%);
  position: absolute;
  z-index: -21;
  content: '';
  top: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-bottom::before {
  border-right: solid 4px transparent;
  border-left: solid 4px transparent;
  transform: translateX(-50%) rotate(180deg);
  position: absolute;
  z-index: -21;
  content: '';
  bottom: 100%;
  left: 50%;
  height: 0;
  width: 0;
}

.tooltip-top.tooltip-color::before {
  border-top: solid 0.5rem rgba(0, 0, 0, 0.6);
}

.tooltip-bottom.tooltip-color::before {
  border-top: solid 0.5rem rgba(0, 0, 0, 0.6);
}

/* 0.5px line  */
.half-1px-line-bottom::after {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  border-color: #828282;
  border-style: solid;
  transform: scale(0.5, 0.5);
  border-radius: 1px;
  box-sizing: border-box;
  pointer-events: none;
  border-width: 0;
  border-bottom-width: 1px;
}

.half-1px-line-top::after {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  border-color: #828282;
  border-style: solid;
  transform: scale(0.5, 0.5);
  border-radius: 1px;
  box-sizing: border-box;
  pointer-events: none;
  border-width: 0;
  border-top-width: 1px;
}

.half-1px-line-left::after {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  border-color: #828282;
  border-style: solid;
  transform: scale(0.5, 0.5);
  border-radius: 1px;
  box-sizing: border-box;
  pointer-events: none;
  border-width: 0;
  border-left-width: 1px;
}

.btn-unset-width {
  min-width: unset !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 4px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(0, 0, 0, 0.4);
}

.filepond--drop-label {
  cursor: pointer;
  background: #edf0f4;
  border-radius: 8px;
}

.filepond--drop-label > label {
  cursor: pointer;
}

.filepond--credits {
  display: none;
}

/* v-dialog */
.v-dialog:not(.v-dialog--fullscreen) {
  border-radius: 0px !important;
}

/* v-data-table */

.v-table__wrapper {
  border-radius: 0px !important;
}

.v-data-table-header__content {
  font-weight: 700 !important;
  font-size: 14px !important;
  line-height: 19px !important;
  color: #1b1b1b !important;
}

.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
  color: #1b1b1b !important;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  color: #1a1a1a !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.v-data-table-footer > .v-data-table-footer__pagination > .v-pagination > .v-pagination__list > .v-pagination__first > .v-btn,
.v-data-table-footer > .v-data-table-footer__pagination > .v-pagination > .v-pagination__list > .v-pagination__prev > .v-btn,
.v-data-table-footer > .v-data-table-footer__pagination > .v-pagination > .v-pagination__list > .v-pagination__next > .v-btn,
.v-data-table-footer > .v-data-table-footer__pagination > .v-pagination > .v-pagination__list > .v-pagination__last > .v-btn {
  color: #1b65f2;
}

/* search bar */
.v-text-field.shadow-textfield > .v-input__control > .v-field--variant-solo {
  background-color: #f5f5f5 !important;
  color: #808080;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.v-text-field--outlined > .v-input__control > .v-input__slot {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}

.v-field__field {
  color: #1b1b1b;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
}
.v-field__field > .v-field__input {
  padding-left: 12px;
}

.v-dialog > .v-card > .v-text-field--outlined > .v-input__control > .v-input__slot fieldset {
  color: rgba(0, 0, 0, 0.2);
}

/* remove spin buttons for number text field  */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance: textfield;
}

/* expansion panel */
div:deep(.v-expansion-panel-header) {
  padding: 12px;
}
.v-expansion-panels--variant-accordion > .v-expansion-panel {
  border-radius: 12px !important;
}
</style>
